import type { Interest } from 'models';
import { useQuery } from 'query';
import { getInterests } from '../services';
import { getInterestsQueryKey } from './keys';

export const useInterests = () =>
  useQuery<Interest[]>({
    async queryFn() {
      const { data } = await getInterests();
      return data;
    },
    queryKey: getInterestsQueryKey(),
  });
